import IApplicationState, { ICompetitionsState } from 'app/types/state';
import _ from 'lodash';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.competitions.competitionsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}
function mapSelectActive(state, n): { value: string; label: string } {
  const sa = state.competitions.competitionsById[n];

  if (sa && sa.status === 'active' && sa.archived !== true) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getCompetitionsByIdInSelectFormat(
  state: IApplicationState,
): any {
  return _.map(state.competitions.competitionIds, (n) => mapSelect(state, n));
}

export function getActiveCompetitionsByIdInSelectFormat(
  state: IApplicationState,
): any {
  return _.filter(_.map(state.competitions.competitionIds, (n) => mapSelectActive(state, n)), null);
}

export function getCurrentCompetition(state: IApplicationState) {
  if (
    state.competitions.competitionsById !== undefined
    && state.competitions.currentCompetitionId !== undefined
  ) {
    return state.competitions.competitionsById[
      state.competitions.currentCompetitionId
    ];
  }
  return {};
}

export function getCompetitionsFilteredByOrganisationInSelectFormat(
  state: IApplicationState,
  organisationId,
): any {
  const { competitionsById }: ICompetitionsState = state.competitions;
  const competitions = _.filter(competitionsById, {
    organisation: { id: organisationId },
  });
  const sortedCompetitions = _.sortBy(competitions, (o) => o.name);
  const mappedSections = _.map(sortedCompetitions, (n) => mapSelect(state, n.id));
  return mappedSections;
}

export function getCurrentFormCompetition(state: IApplicationState) {
  return {
    ...getCurrentCompetition(state),
    ...state.competitions.requestedData,
  };
}

export function getCompetition(state, competition): any {
  if (competition != null) {
    return {
      ...competition,
    };
  }
  return {};
}

export function getCompetitionById(state, id): any {
  if (state.competitions.competitionsById !== undefined && id != null) {
    return getCompetition(state, state.competitions.competitionsById[id]);
  }
  return {};
}

export function getCompetitions(state: IApplicationState) {
  return {
    ...state.competitions,
    currentCompetition: {
      ...getCurrentCompetition(state),
    },
    competitionsByIdInSelectFormat: getCompetitionsByIdInSelectFormat(state),
    activeCompetitionsByIdInSelectFormat: getActiveCompetitionsByIdInSelectFormat(state),
    competitionsFilteredByOrganisationInSelectFormat: (organisationId): any => getCompetitionsFilteredByOrganisationInSelectFormat(state, organisationId),
  };
}

export function getCompetitionSummary(competition): any {
  const competitionSummary = {
    id: competition.id,
    name: competition.name,
    friendlyCode: competition.friendlyCode,
    archived: competition.archived,
    status: competition.status,
  };
  return competitionSummary;
}
